import { Fragment } from "react";

import { SiteContext } from "../../../../Contexts/SiteContext";

import { pickDataValuesForButtonsGTM } from "../../../../../utils/data.layer.utils/buttons.data.layer.util";

import { getBlockId } from "../../../../../utils/forms/form.fields.utils";

import { ProductViewEntryButton } from "./atoms/EntryButton";
import { ProductViewDownloadButton } from "./atoms/DownloadButton";
import { ProductViewFormButton } from "./atoms/FormButton";
import { ProductViewLinkButton} from "./atoms/LinkButton";

const CallToAction = props => {	
	const { category = null, slug = null, block, setOpenBATD, getFormData, pageData } = props;

	const { url, title } = pageData;

	const { data } = block;

	const grid = (deviceType) => {
		if (deviceType == 'desktop') {
			return { flex: '1 0 0%' };
		} else if (deviceType == 'tablet' || deviceType == 'mobile') {
			if (data && data.length == 4) {
				return { flex: '1 0 50%' };
			}
			return { flex: '1 0 33%', };
		}
	};

	const renderButton = (button) => {
		const trackingVals = {
			title,
			url,
		};

		if (button.type === 'entry') {
			return (
				<ProductViewEntryButton
					trackingVals={{
						...pickDataValuesForButtonsGTM(category, slug, button),
						...trackingVals
					}}
					button={button}
				/>
			);
		} else if (button.type === 'download') {
			return (
				<ProductViewDownloadButton
					trackingVals={{
						...pickDataValuesForButtonsGTM(category, slug, button),
						...trackingVals
					}} 
					button={button}
				/>
			);
		} else if (button.type === 'form') {
			return (
				<ProductViewFormButton
					trackingVals={{
						...pickDataValuesForButtonsGTM(category, slug, button),
						...trackingVals
					}}
					setOpenBATD={setOpenBATD}
					getFormData={getFormData} 
					button={button}
				/>
			);
		} else if (button.type === 'link') {
			return (
				<ProductViewLinkButton 
					trackingVals={{
						...pickDataValuesForButtonsGTM(category, slug, button),
						...trackingVals
					}}
					button={button}
				/>
			);
		}
	}

	return (
		<SiteContext.Consumer>
			{({ deviceType }) => (
				<Fragment>
					<div className="customContainer mt64px mb64px" id={getBlockId(block)}>
						<div className="row">
							<div className="col s12 m10 l10 offset-m1 offset-l1">
								<div className="flexcontainer cta_tool">
									{data.map((item, i) => (
										<div style={grid(deviceType)} key={`call-to-action-${i}`}>
											<div className="toolHolder">
												{renderButton(item)}
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</Fragment>
			)}
		</SiteContext.Consumer>

	);
};

export default CallToAction;